import {newStepValue} from '../../../../services/flowBuilder/utils/constants';


const chat2payPredefined = {
    json: {
        menu: {
            menuType: 'chat2pay',
            payment: {
                extension: '',
                messageForLink: '',
                currencyCode: 'USD',
                currency: 'predefined',
                amount: '',
                tax: '',
                itemDescription: '',
                autoReversePayment: false,
                confirmationMessage: ''
            },
            menuParams: {
                apiToken: ''
            },
            results: {
                PAYMENT_COMPLETED: {
                    next: newStepValue,
                    description: 'Payment Succeeds',
                },
                PAYMENT_DECLINED: {
                    next: newStepValue,
                    description: 'Payment Failed',
                },
                PAYMENT_UNKNOWN: {
                    next: newStepValue,
                    description: 'Payment Unknown',
                },
                PAYMENT_REVIEW: {
                    next: newStepValue,
                    description: 'Payment requires a review',
                },
                TIMEOUT: {
                    next: newStepValue,
                    description: 'Timeout',
                },
                ERROR: {
                    next: newStepValue,
                    description: 'Communications error with Chat2Pay'
                }
            },
        },
        type: 'menu',
        metadata: {},
    },
    paths: [
        'menu.payment.extension',
        'menu.payment.messageForLink',
        'menu.payment.currencyCode',
        'menu.payment.currency',
        'menu.payment.amount',
        'menu.payment.tax',
        'menu.results.PAYMENT_COMPLETED.description',
        'menu.payment.confirmationMessage',
        'menu.results.PAYMENT_COMPLETED.next',
        'menu.results.PAYMENT_DECLINED.description',
        'menu.results.PAYMENT_DECLINED.next',
        'menu.results.PAYMENT_REVIEW.description',
        'menu.payment.autoReversePayment',
        'menu.results.PAYMENT_REVIEW.next',
        'menu.results.PAYMENT_UNKNOWN.description',
        'menu.results.PAYMENT_UNKNOWN.next',
        'menu.results.TIMEOUT.description',
        'menu.results.TIMEOUT.next',
        'menu.results.ERROR.description',
        'menu.results.ERROR.next',
    ],
    groups: [
        {
            'Parameters': [
                'menu.payment.extension',
                'menu.payment.messageForLink',
                'menu.payment.currency',
                'menu.payment.amount',
                'menu.payment.tax'
            ]
        },
        {
            'Logic': [
                'menu.results.PAYMENT_COMPLETED.description',
                'menu.payment.confirmationMessage',
                'menu.results.PAYMENT_COMPLETED.next',
                'menu.results.PAYMENT_DECLINED.description',
                'menu.results.PAYMENT_DECLINED.next',
                'menu.results.PAYMENT_REVIEW.description',
                'menu.payment.autoReversePayment',
                'menu.results.PAYMENT_REVIEW.next',
                'menu.results.PAYMENT_UNKNOWN.description',
                'menu.results.PAYMENT_UNKNOWN.next',
                'menu.results.TIMEOUT.description',
                'menu.results.TIMEOUT.next',
                'menu.results.ERROR.description',
                'menu.results.ERROR.next',
            ]
        },
    ]
};

const chat2payVariable = {
    json: {
        menu: {
            menuType: 'chat2pay',
            payment: {
                extension: '',
                messageForLink: '',
                currencyCode: 'USD',
                currency: 'variable',
                amount: '',
                tax: '',
                itemDescription: '',
                autoReversePayment: false,
                confirmationMessage: ''
            },
            menuParams: {
                apiToken: ''
            },
            results: {
                PAYMENT_COMPLETED: {
                    next: newStepValue,
                    description: 'Payment Succeeds',
                },
                PAYMENT_DECLINED: {
                    next: newStepValue,
                    description: 'Payment Failed',
                },
                PAYMENT_UNKNOWN: {
                    next: newStepValue,
                    description: 'Payment Unknown',
                },
                PAYMENT_REVIEW: {
                    next: newStepValue,
                    description: 'Payment requires a review',
                },
                TIMEOUT: {
                    next: newStepValue,
                    description: 'Timeout',
                },
                ERROR: {
                    next: newStepValue,
                    description: 'Communications error with Chat2Pay'
                }
            },
        },
        type: 'menu',
        metadata: {},
    },
    paths: [
        'menu.payment.extension',
        'menu.payment.messageForLink',
        'menu.payment.currency',
        'menu.payment.currencyCode',
        'menu.payment.amount',
        'menu.payment.tax',
        'menu.results.PAYMENT_COMPLETED.description',
        'menu.payment.confirmationMessage',
        'menu.results.PAYMENT_COMPLETED.next',
        'menu.results.PAYMENT_DECLINED.description',
        'menu.results.PAYMENT_DECLINED.next',
        'menu.results.PAYMENT_REVIEW.description',
        'menu.payment.autoReversePayment',
        'menu.results.PAYMENT_REVIEW.next',
        'menu.results.PAYMENT_UNKNOWN.description',
        'menu.results.PAYMENT_UNKNOWN.next',
        'menu.results.TIMEOUT.description',
        'menu.results.TIMEOUT.next',
        'menu.results.ERROR.description',
        'menu.results.ERROR.next',
    ],
    groups: [
        {
            'Parameters': [
                'menu.payment.extension',
                'menu.payment.messageForLink',
                'menu.payment.currency',
                'menu.payment.currencyCode',
                'menu.payment.amount',
                'menu.payment.tax',
            ]
        },
        {
            'Logic': [
                'menu.results.PAYMENT_COMPLETED.description',
                'menu.payment.confirmationMessage',
                'menu.results.PAYMENT_COMPLETED.next',
                'menu.results.PAYMENT_DECLINED.description',
                'menu.results.PAYMENT_DECLINED.next',
                'menu.results.PAYMENT_REVIEW.description',
                'menu.payment.autoReversePayment',
                'menu.results.PAYMENT_REVIEW.next',
                'menu.results.PAYMENT_UNKNOWN.description',
                'menu.results.PAYMENT_UNKNOWN.next',
                'menu.results.TIMEOUT.description',
                'menu.results.TIMEOUT.next',
                'menu.results.ERROR.description',
                'menu.results.ERROR.next',
            ]
        },
    ]
};

export const chat2pay = {
    json: {
        menu: {
            menuType: 'chat2pay',
            payment: {
                extension: '',
                messageForLink: '',
                currencyCode: 'USD',
                currency: 'predefined',
                amount: '',
                tax: '',
                itemDescription: '',
                autoReversePayment: false,
                confirmationMessage: ''
            },
            menuParams: {
                apiToken: ''
            },
            results: {
                PAYMENT_COMPLETED: {
                    next: newStepValue,
                    description: 'Payment Succeeds',
                },
                PAYMENT_DECLINED: {
                    next: newStepValue,
                    description: 'Payment Failed',
                },
                PAYMENT_REVIEW: {
                    next: newStepValue,
                    description: 'Payment requires a review',
                },
                PAYMENT_UNKNOWN: {
                    next: newStepValue,
                    description: 'Payment Unknown',
                },
                TIMEOUT: {
                    next: newStepValue,
                    description: 'End user timeout',
                },
                ERROR: {
                    next: newStepValue,
                    description: 'Communications error with Chat2Pay'
                }
            },
        },
        type: 'menu',
        metadata: {},
    },
    paths: [
        'menu.payment.extension',
        'menu.payment.messageForLink',
        'menu.payment.currencyCode',
        'menu.payment.currency',
        'menu.payment.amount',
        'menu.payment.tax',
        'menu.results.PAYMENT_COMPLETED.description',
        'menu.payment.confirmationMessage',
        'menu.results.PAYMENT_COMPLETED.next',
        'menu.results.PAYMENT_DECLINED.description',
        'menu.results.PAYMENT_DECLINED.next',
        'menu.results.PAYMENT_REVIEW.description',
        'menu.payment.autoReversePayment',
        'menu.results.PAYMENT_REVIEW.next',
        'menu.results.PAYMENT_UNKNOWN.description',
        'menu.results.PAYMENT_UNKNOWN.next',
        'menu.results.TIMEOUT.description',
        'menu.results.TIMEOUT.next',
        'menu.results.ERROR.description',
        'menu.results.ERROR.next',
    ],
    groups: [
        {
            'Parameters': [
                'menu.payment.extension',
                'menu.payment.messageForLink',
                'menu.payment.currency',
                'menu.payment.currencyCode',
                'menu.payment.amount',
                'menu.payment.tax'
            ]
        },
        {
            'Logic': [
                'menu.results.PAYMENT_COMPLETED.description',
                'menu.payment.confirmationMessage',
                'menu.results.PAYMENT_COMPLETED.next',
                'menu.results.PAYMENT_DECLINED.description',
                'menu.results.PAYMENT_DECLINED.next',
                'menu.results.PAYMENT_REVIEW.description',
                'menu.payment.autoReversePayment',
                'menu.results.PAYMENT_REVIEW.next',
                'menu.results.PAYMENT_UNKNOWN.description',
                'menu.results.PAYMENT_UNKNOWN.next',
                'menu.results.TIMEOUT.description',
                'menu.results.TIMEOUT.next',
                'menu.results.ERROR.description',
                'menu.results.ERROR.next',
            ]
        },
    ],
    layout: {
        apiToken: {
            type: 'hidden',
            label: '',
            validators: {
                required: true,
            }
        },
        name: {
            type: 'text',
            label: 'Step Title',
            validators: {
                required: true,
            }
        },
        currency: {
            type: 'selector',
            label: 'Currency',
            attributes: {
                options: {
                    variable: 'Variable',
                    predefined: 'Predefined'
                },
                data: true,
            },
            validators: {
                required: true,
                optionSelected: true
            }
        },
        amount: {
            type: 'searchable-dropdown',
            label: 'Amount',
            placeholder: 'Enter amount',
            attributes: {
                setValue: 'menu.payment.currencyCode'
            },
            validators: {
                required: true
            }
        },
        currencyCode: {
            type: 'text',
            label: 'Currency Variable',
            placeholder: 'Enter variable',
            attributes: {
                readonly: true
            },
            validators: {
                required: true,
            }
        },
        extension: {
            type: 'dropdown',
            label: 'Select Extension',
            attributes: {
                options: {},
                data: false,
            },
            validators: {
                required: true,
                optionSelected: true
            }
        },
        messageForLink: {
            type: 'textarea',
            label: 'Message for Link',
            placeholder: 'Enter a message for the end-user to see before the Chat 2 Pay link.',
            validators: {
                required: true,
            }
        },
        tax: {
            type: 'number',
            label: 'Tax %',
            placeholder: 'Enter percent amount',
            attributes: {
                symbol: '%',
                optional: true
            },
            validators: {
                required: false,
            }
        },
        autoReversePayment: {
            type: 'checkbox-single',
            label: 'Auto Reverse Payment',
            validators: {
                required: true,
            }
        },
        confirmationMessage: {
            type: 'textarea',
            label: 'Confirmation Message',
            placeholder: 'Preheader text...',
            validators: {
                required: true,
            }
        },
        description: {
            type: 'text-with-key',
            label: 'Result',
            attributes: {
                valueLabel: 'Description',
            },
            validators: {
                required: true,
            }
        },
        next: {
            type: 'next',
            label: 'Next',
            attributes: {
                class: 'end-of-logic-block'
            },
            validators: {
                optionSelected: true
            }
        }
    },
    data: {
        results: {
            next: newStepValue,
            description: ''
        },
        dataPath: 'menu.payment.currency',
        currency: {
            variable: chat2payVariable,
            predefined: chat2payPredefined
        },
    }
};


export class Chat2PayCurrency {
    iso: string;
    name: string;
    symbol: string;
    isDefault: boolean;
}

export class Chat2PayConfig {
    status: string;
    type: string;
    name: string;
    id: string;
    integrators: [];
    apiKey: string;
    enabledChannels: Array<string>;
    supportedCurrencies: Array<Chat2PayCurrency>;
}


